import { useEffect, useState } from 'react'

import { useGetLeaderboardDataQuery } from '~/Leaderboard/apis/leaderboard-api'
import Unranked from '~/Leaderboard/components/Unranked'
import CurrentLeaderboard from '~/Leaderboard/components/CurrentLeaderboard'
import { isAuthenticated } from '~/auth/slices/auth.slice'

import HouseOfMathLoader from '~/components/HouseOfMathLoader'

import useCurrentUser from '~/hooks/useCurrentUser'
import { useAppSelector } from '~/redux/hooks'
import NotParticipating from '~/Leaderboard/components/NotParticipating'
import LeaderboardWrapper from '~/Leaderboard/components/LeaderboardWrapper'

export default function Leaderboard(): React.ReactElement {
  const [timeToReset, setTimeToReset] = useState(0)
  const user = useCurrentUser()
  const authenticated = useAppSelector(isAuthenticated)

  const leaderboardData = useGetLeaderboardDataQuery(undefined, { skip: !authenticated })

  useEffect(() => {
    if (!leaderboardData.data) return
    setTimeToReset(leaderboardData.data.seasonEndInSec)
  }, [leaderboardData.data])

  useEffect(() => {
    if (timeToReset <= 0) return
    const interval = setInterval(() => {
      setTimeToReset((prevState) => prevState - 20)
    }, 20000)
    return () => clearInterval(interval)
  })

  if (!authenticated) {
    return (
      <LeaderboardWrapper currentLeague={0} highestLeague={0} leaderboardCapacity={0} timeToReset={timeToReset}>
        <Unranked user={null} />
      </LeaderboardWrapper>
    )
  }

  if (leaderboardData.data && !leaderboardData.data.userWantsToBeInLeaderboard) {
    return (
      <LeaderboardWrapper
        currentLeague={0}
        highestLeague={leaderboardData.data?.highestLeague || 0}
        leaderboardCapacity={0}
        notParticipating
        timeToReset={timeToReset}
      >
        <NotParticipating user={user} />
      </LeaderboardWrapper>
    )
  }

  return (
    <LeaderboardWrapper
      currentLeague={leaderboardData.data?.currentLeague || 1}
      highestLeague={leaderboardData.data?.highestLeague || 1}
      leaderboardCapacity={leaderboardData.data?.leaderboardCapacity || 0}
      promotionSettings={leaderboardData.data?.promotionSettings}
      timeToReset={timeToReset}
    >
      {!leaderboardData.isSuccess && !leaderboardData.data ? (
        <div className="py-20">
          <HouseOfMathLoader />
        </div>
      ) : (
        <CurrentLeaderboard leaderboardData={leaderboardData.data} user={user} />
      )}
    </LeaderboardWrapper>
  )
}
